import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { NoticeService } from "../../../../swaggerServices";

@Injectable()
export class NoticeEmailRouteResolver   {
  constructor(private router: Router, private noticeService: NoticeService) { }

  resolve(route: ActivatedRouteSnapshot) {
    const noticeId = Number(route.paramMap.get('noticeId'));
    return this.noticeService.getTaxpayerEmailTemplateForNotice(noticeId);
  }
}
